// API Configuration
// Único punto de verdad para la URL base del backend (sin /api/v1 —
// cada servicio agrega el prefijo). Antes había 3 valores distintos
// repartidos entre config.js, api.js y llamadas sueltas; se unificó aquí.
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
